import { CheckCircle2, CalendarCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WA_SCHEDULE } from "@/lib/constants";

const SIGNS = [
  "Dor persistente",
  "Limitação de movimento",
  "Dores após lesões",
  "Dificuldade para realizar atividades",
  "Dores relacionadas a esportes",
  "Desconfortos que afetam a rotina",
];

export const WhenToSeek = () => (
  <section id="ortopedista" data-testid="when-to-seek-section" className="bg-cob-beige/50 py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <SectionHeading
            overline="Informação é cuidado"
            title="Quando procurar um ortopedista?"
            text="Alguns sinais indicam que é hora de buscar uma avaliação especializada. Cuidar cedo faz diferença na recuperação e na qualidade de vida."
          />
          <Reveal delay={0.24}>
            <a
              href={WA_SCHEDULE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="when-to-seek-cta"
              className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-cob-green px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-cob-dark hover:shadow-[0_16px_35px_-12px_rgba(6,63,50,0.5)]"
            >
              <CalendarCheck className="h-4.5 w-4.5" />
              Agende uma avaliação
            </a>
          </Reveal>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {SIGNS.map((sign, i) => (
            <Reveal key={sign} delay={0.08 + i * 0.07}>
              <div
                data-testid={`when-to-seek-item-${i + 1}`}
                className="flex items-start gap-3 rounded-2xl border border-cob-light bg-white p-5 transition-all duration-300 hover:border-cob-gold/50 hover:shadow-[0_14px_30px_-18px_rgba(6,63,50,0.3)]"
              >
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-cob-gold" strokeWidth={1.8} />
                <span className="text-[15px] font-medium leading-snug text-cob-ink">{sign}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
